<template>
  <b-row>
     <b-spinner v-if="load" type="grow" label="Loading..."  class="loading" />
    <b-col lg="12" v-for="item in contents" :key="item.title">
      <b-card :title="item.title">
        <b-table :stacked="($mobile==1)"  responsive="sm" :items="item.items" :fields="userfields">
          <template #cell(ch)="data">
            {{ data.item.pivot.ch }}
          </template>
        </b-table>
       
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import EduProgramsController from "@/Controllers/EduProgramsController";
import SemesterController from "@/Controllers/SemesterController";
export default {
  data() {
    return {
      contents: [],
      text: "",
      textCh: "",
      load: false,

      userfields: [
        {
          key: "code",
          label: this.$i18n.t("edu_courses.code"),
          sortable: true,
        },
        {
          key: "name",
          label: this.$i18n.t("edu_courses.name"),
          sortable: true,
        },
        // {
        //   key: "ch",
        //   label: "CH",
        //   sortable: true,
        // },
      ],
    };
  },
  async created() {
    this.load = true;
    var id = localStorage.getItem("eduProgram");
    if (!id) {
      id = this.$route.params.eduProgramId;
    }
    let res = await new EduProgramsController().getExcelByProgram(id, true);
    let semester = await new SemesterController().GetAll({
      filter: "edu_program_id|" + id,
    });
    this.programCourses = res.courses;
    semester.forEach((element) => {
      let programCoursesData = this.programCourses.filter(
        (a) => a.pivot.semester == element.id && a.flixable == 0
      );
      this.contents.push({
        title: element.name,
        items: programCoursesData,
      });
    });
    this.load = false;
  },
  methods: {},
};
</script>

<style>
</style>